import React, { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ margin: '100px' }}>
          <h2>{'Hopa, a apărut o eroare :('}</h2>
          {'Echipa Artistic Home a fost notificată!'}
          <p style={{ color: '#FE5252', fontWeight: 'bold' }}>
            {this.state.error && this.state.error.toString()}
          </p>
          {/* <div>{'Component Stack Error Details: '}</div>
          <p style={{ color: '#FE5252' }}>
            {this.state.errorInfo.componentStack}
          </p> */}
        </div>
      );
    }
    return this.props.children;
  }
}
